import { createRandomString, decode, encode } from './random';

export const decodeNonce = (encodedNonce: string): string => {
  return decode(encodedNonce);
};

export const generateNonce = (): string => {
  return encode(createRandomString(43));
};
